import React from 'react'
import { AWS_S3_URL } from 'utils/constants'
import { Button } from '@conekta/frontino-ui/Button'
import { IFrontIdModalType } from 'components/FrontIdModal/FrontIdModal.type'
import { useTranslation } from 'react-i18next'
import './FrontIdModal.scss'

export const FrontIdModal = ({ hiddenModal, open }: IFrontIdModalType) => {
  const { t } = useTranslation()
  const T_ROOT = 'wizard.modals.front_id'
  const title = t(`${T_ROOT}.title`)
  const cancelButton = t(`${T_ROOT}.cancel-button`)
  const uploadButton = t(`${T_ROOT}.upload-button`)

  const checkList = [
    t(`${T_ROOT}.${'check-1'}`),
    t(`${T_ROOT}.${'check-2'}`),
    t(`${T_ROOT}.${'check-3'}`),
    t(`${T_ROOT}.${'check-4'}`)
  ]

  return (
    <div className={'front-id-modal__container'}>
      <div className={'front-id-modal__container--title'}>
        <label>{title}</label>
      </div>
      <div className={'front-id-modal__container--image'}>
        <img src={`${AWS_S3_URL}/img/id-front-document.svg`} alt='icon' className='image' />
      </div>
      <div className={'front-id-modal__container--text-list'}>
        {checkList.map((text, index) => (
          <li className={'check-list'} key={`modal-id-front-${index}`}>
            {text}
          </li>
        ))}
      </div>

      <div className={'front-id-modal__container--buttons'}>
        <Button onClick={hiddenModal} className={'front-id-modal action-button-style'} variant='terciary'>
          {cancelButton}
        </Button>

        <Button className={'front-id-modal action-button-blue'} variant='terciary' onClick={open}>
          {uploadButton}
        </Button>
      </div>
    </div>
  )
}
